export enum Player {
  'X' = 'X',
  'O' = 'O',
}

export type BoardData = Array<Array<Player>>;
